import React from 'react'
import Navbar from '../component/common/Navbar'
import TopNav from '../component/common/TopNav'
import HomeSlider from '../component/home/HomeSlider'
import Footer from '../component/common/Footer'
import HomeGiftBoxComponent from '../component/home/HomeGiftBoxComponent'
import JaipuriSetHomePage  from '../component/home/JaipuriSetHomePage'
import HomeTestimonials from '../component/home/HomeTestimonials'
import HomeCustomerWalls from '../component/home/HomeCustomerWalls'


function HomePage() {
  return (
    <div>
      <HomeSlider/>
      <HomeGiftBoxComponent/>
      <JaipuriSetHomePage/>

      <HomeCustomerWalls/>
      <HomeTestimonials/>



    </div>
  )
}

export default HomePage